import React, { useLayoutEffect, useRef } from "react";
import isEmpty from "lodash/isEmpty";
import ContentSection from "../../../common/ContentSection";
import useStaticPageContent from "../../../../../hooks/useStaticPageContent";
import Page404 from "../../Page404";
import Loader from "../../../common/Loader";
import withTranslations from "../../../../../hocs/withTranslations";
import SeoMetaData from "../../../common/SeoMetaData/modules/default";
import { UrlProvider } from "../../../../../api/UrlProvider";
import NoPermissionModal from "../../Plans/components/NoPermissionModal";
import { compose } from "redux";
import { withRouter } from "react-router-dom";

import "../styles/default.scss";
import SignInRequiredPage from "../../../landingPage/pages/Plans/components/SignInRequiredPage/SignInRequiredPage";

function GenericStaticPage({
  match: { params },
  locale,
  history,
  slug = "",
  renderInPlace = false
}) {
  const { response, loading, error, seoDataResponse } = useStaticPageContent({
    slug: params.slug || slug,
    locale
  });
  const scriptContainerRef = useRef(null);

  useLayoutEffect(() => {
    const container = scriptContainerRef.current;
    if (loading || !response?.script || !container) return undefined;

    const script = document.createElement("script");
    script.textContent = response.script;
    container.appendChild(script);

    return () => {
      container.replaceChildren();
    };
  }, [loading, response?.script, response?.content]);

  if (!loading && error) {
    const status = error?.response?.status;

    switch (status) {
      case 401:
        return <SignInRequiredPage />;

      case 403:
        return (
          <NoPermissionModal
            permissions={error?.response?.data?.permissions}
            onClose={() => {
              history.push(UrlProvider.getUrl("fe.home", { locale }));
            }}
          />
        );

      default:
        return <Page404 />;
    }
  }

  const content = (
    <>
      {!!seoDataResponse && !isEmpty(seoDataResponse) ? (
        <SeoMetaData {...seoDataResponse} />
      ) : null}
      {loading ? (
        <Loader />
      ) : response?.content ? (
        <>
          <div dangerouslySetInnerHTML={{ __html: response.content }} />
          {response.script ? <div ref={scriptContainerRef} /> : null}
        </>
      ) : null}
    </>
  );

  if (renderInPlace) {
    return content;
  }

  return <ContentSection>{content}</ContentSection>;
}

const arePropsEqual = (prevProps, nextProps) =>
  prevProps.locale === nextProps.locale &&
  prevProps.history === nextProps.history &&
  prevProps.match?.params?.slug === nextProps.match?.params?.slug;

export default compose(
  withRouter,
  withTranslations
)(React.memo(GenericStaticPage, arePropsEqual));
